<script lang="ts" setup>

interface Props {
  paragraph: string,
}

defineProps<Props>()
</script>

<template>
  <p v-html="paragraph"/>
</template>


<style lang="scss">
  .paragraph {
    &__description {

      margin: 1rem 0;
      line-height: 1.1;
    }
  }
</style>
